import { j as r } from "../../../jsx-runtime-82a9ddf6.js";
const n = ({ width: o = 18, height: e = 18 }) => /* @__PURE__ */ r.jsx("svg", { style: { minWidth: o }, width: o, height: e, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ r.jsx(
  "path",
  {
    d: "M11.25 7.5L8.25 10.5L12.75 15L15.75 3L2.25 8.25L5.25 9.75L6.75 14.25L9 11.25",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
) });
export {
  n as TelegramIcon
};
